module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-memorial-right-a117d47ab95f4bc2bf2ece48858f9a13.svg";